import { uploadFile, type FileFromOptions } from "@uploadcare/upload-client"

import { captureThirdPartyError, SENTRY_INTEGRATIONS } from "~utils/sentry"

interface UploadFileToUploadcareProps {
    readonly file: File
    readonly sentryAction: string
    readonly onProgress?: FileFromOptions["onProgress"]
}

// Single entry point for programmatic Uploadcare uploads so the public key
// and Sentry capture are not duplicated at every call site. UI-driven
// uploads should keep using `UploadcareModal` from lib-react-components.
export async function uploadFileToUploadcare({
    file,
    sentryAction,
    onProgress,
}: UploadFileToUploadcareProps) {
    try {
        return await uploadFile(file, {
            publicKey: process.env.GATSBY_UPLOAD_CARE_PK || "",
            fileName: file.name || undefined,
            onProgress,
        })
    } catch (error) {
        captureThirdPartyError(
            error,
            SENTRY_INTEGRATIONS.UPLOADCARE,
            sentryAction
        )
        throw error
    }
}
